<template lang="pug">
div.alert.alert-info
  p {{$t('Неизвестный способ платежа.')}}
</template>

<script lang="ts" setup>
import {onMounted, ref} from "vue";

const emit = defineEmits(['created', 'model-loaded'])

const submitable = ref(false);

const setSourceAccountNumber = (value: string) => {
}

onMounted(() => {
  emit('created', false);
  emit('model-loaded');
});

defineExpose({
  setSourceAccountNumber
});
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Неизвестный способ платежа.": "Unknown payment method."
  }
}
</i18n>
